/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingsPageAttackListSenderEditViewSettingFragmentDoc, SettingsPageAttackListSenderEditViewEntranceFragmentDoc } from './SettingsPageAttackListSenderEditView.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
/** パートナー、子どもの存在を表すルールに使う */
export type AttackListSenderSettingRuleExistence =
  /** 存在する */
  | 'EXIST'
  /** 存在しない */
  | 'NOT_EXIST'
  /** 指定しない(存在してもしなくてもいい) */
  | 'NOT_SPECIFIED';

export type AttackListSenderSettingRuleGender =
  | 'FEMALE'
  | 'MALE'
  /** 性別は指定しない */
  | 'NOT_SPECIFIED';

export type AttackListSenderSettingRuleInput = {
  age?: AttackListSenderSettingRuleRangeInput | null | undefined;
  ageOfFirstChildRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  ageOfYoungestChildRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  annualIncomeRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  child: AttackListSenderSettingRuleExistence;
  diagnosisType?: DiagnosisType | null | undefined;
  familyAnnualIncomeRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  gender: AttackListSenderSettingRuleGender;
  investmentRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  jobId?: string | number | null | undefined;
  karteTopicId?: string | number | null | undefined;
  loanBalanceRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  partner: AttackListSenderSettingRuleExistence;
  savingRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  shouldSendIfSameCorporationApproached: boolean;
};

export type AttackListSenderSettingRuleRangeInput = {
  max?: number | null | undefined;
  min?: number | null | undefined;
};

export type DiagnosisType =
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G'
  | 'H';

export type UpdateAttackListSenderSettingInput = {
  body: string;
  entranceGuid?: string | number | null | undefined;
  id: string | number;
  isEnabled: boolean;
  plannerId?: string | number | null | undefined;
  rule: AttackListSenderSettingRuleInput;
  selections: Array<string>;
  title: string;
};

export type FetchOnSettingsPageAttackListSenderUpdateViewQueryVariables = Exact<{
  attackListSenderSettingId: string | number;
}>;


export type FetchOnSettingsPageAttackListSenderUpdateViewQuery = { viewer: { attackListSender: { availableCorporationEntrances: Array<{ guid: string, name: string }> } }, attackListSenderSetting: { id: string, isEnabled: boolean, title: string, body: string, selections: Array<string>, planner: { id: string }, entrance: { guid: string }, rule: { partner: Types.AttackListSenderSettingRuleExistence, child: Types.AttackListSenderSettingRuleExistence, gender: Types.AttackListSenderSettingRuleGender, shouldSendIfSameCorporationApproached: boolean, savingRange: { min: number | null, max: number | null } | null, annualIncomeRange: { min: number | null, max: number | null } | null, familyAnnualIncomeRange: { min: number | null, max: number | null } | null, ageOfFirstChildRange: { min: number | null, max: number | null } | null, age: { min: number | null, max: number | null } | null, investmentRange: { min: number | null, max: number | null } | null } } };

export type UpdateAttackListSenderSettingMutationVariables = Exact<{
  input: Types.UpdateAttackListSenderSettingInput;
}>;


export type UpdateAttackListSenderSettingMutation = { updateAttackListSenderSetting: { id: string, isEnabled: boolean, title: string, body: string, selections: Array<string>, rule: { partner: Types.AttackListSenderSettingRuleExistence, child: Types.AttackListSenderSettingRuleExistence, gender: Types.AttackListSenderSettingRuleGender, shouldSendIfSameCorporationApproached: boolean, savingRange: { min: number | null, max: number | null } | null, annualIncomeRange: { min: number | null, max: number | null } | null, familyAnnualIncomeRange: { min: number | null, max: number | null } | null, ageOfFirstChildRange: { min: number | null, max: number | null } | null, age: { min: number | null, max: number | null } | null, investmentRange: { min: number | null, max: number | null } | null }, entrance: { guid: string }, planner: { id: string, name: string } } };

export type DeleteAttackListSenderSettingMutationVariables = Exact<{
  ids: Array<string | number> | string | number;
}>;


export type DeleteAttackListSenderSettingMutation = { deleteAttackListSenderSettings: { isSucceeded: boolean } };


export const FetchOnSettingsPageAttackListSenderUpdateViewDocument = gql`
    query FetchOnSettingsPageAttackListSenderUpdateView($attackListSenderSettingId: ID!) {
  viewer {
    attackListSender {
      availableCorporationEntrances {
        ...SettingsPageAttackListSenderEditViewEntrance
      }
    }
  }
  attackListSenderSetting(id: $attackListSenderSettingId) {
    ...SettingsPageAttackListSenderEditViewSetting
  }
}
    ${SettingsPageAttackListSenderEditViewEntranceFragmentDoc}
${SettingsPageAttackListSenderEditViewSettingFragmentDoc}`;

/**
 * __useFetchOnSettingsPageAttackListSenderUpdateViewQuery__
 *
 * To run a query within a Vue component, call `useFetchOnSettingsPageAttackListSenderUpdateViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOnSettingsPageAttackListSenderUpdateViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchOnSettingsPageAttackListSenderUpdateViewQuery({
 *   attackListSenderSettingId: // value for 'attackListSenderSettingId'
 * });
 */
export function useFetchOnSettingsPageAttackListSenderUpdateViewQuery(variables: FetchOnSettingsPageAttackListSenderUpdateViewQueryVariables | VueCompositionApi.Ref<FetchOnSettingsPageAttackListSenderUpdateViewQueryVariables> | ReactiveFunction<FetchOnSettingsPageAttackListSenderUpdateViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchOnSettingsPageAttackListSenderUpdateViewQuery, FetchOnSettingsPageAttackListSenderUpdateViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchOnSettingsPageAttackListSenderUpdateViewQuery, FetchOnSettingsPageAttackListSenderUpdateViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchOnSettingsPageAttackListSenderUpdateViewQuery, FetchOnSettingsPageAttackListSenderUpdateViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchOnSettingsPageAttackListSenderUpdateViewQuery, FetchOnSettingsPageAttackListSenderUpdateViewQueryVariables>(FetchOnSettingsPageAttackListSenderUpdateViewDocument, variables, options);
}
export function useFetchOnSettingsPageAttackListSenderUpdateViewLazyQuery(variables?: FetchOnSettingsPageAttackListSenderUpdateViewQueryVariables | VueCompositionApi.Ref<FetchOnSettingsPageAttackListSenderUpdateViewQueryVariables> | ReactiveFunction<FetchOnSettingsPageAttackListSenderUpdateViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchOnSettingsPageAttackListSenderUpdateViewQuery, FetchOnSettingsPageAttackListSenderUpdateViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchOnSettingsPageAttackListSenderUpdateViewQuery, FetchOnSettingsPageAttackListSenderUpdateViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchOnSettingsPageAttackListSenderUpdateViewQuery, FetchOnSettingsPageAttackListSenderUpdateViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchOnSettingsPageAttackListSenderUpdateViewQuery, FetchOnSettingsPageAttackListSenderUpdateViewQueryVariables>(FetchOnSettingsPageAttackListSenderUpdateViewDocument, variables, options);
}
export type FetchOnSettingsPageAttackListSenderUpdateViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchOnSettingsPageAttackListSenderUpdateViewQuery, FetchOnSettingsPageAttackListSenderUpdateViewQueryVariables>;
export const UpdateAttackListSenderSettingDocument = gql`
    mutation updateAttackListSenderSetting($input: UpdateAttackListSenderSettingInput!) {
  updateAttackListSenderSetting(input: $input) {
    id
    isEnabled
    title
    body
    selections
    rule {
      savingRange {
        min
        max
      }
      annualIncomeRange {
        min
        max
      }
      familyAnnualIncomeRange {
        min
        max
      }
      partner
      child
      ageOfFirstChildRange {
        min
        max
      }
      gender
      age {
        min
        max
      }
      investmentRange {
        min
        max
      }
      shouldSendIfSameCorporationApproached
    }
    entrance {
      guid
    }
    planner {
      id
      name
    }
  }
}
    `;

/**
 * __useUpdateAttackListSenderSettingMutation__
 *
 * To run a mutation, you first call `useUpdateAttackListSenderSettingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttackListSenderSettingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAttackListSenderSettingMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAttackListSenderSettingMutation(options: VueApolloComposable.UseMutationOptions<UpdateAttackListSenderSettingMutation, UpdateAttackListSenderSettingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAttackListSenderSettingMutation, UpdateAttackListSenderSettingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAttackListSenderSettingMutation, UpdateAttackListSenderSettingMutationVariables>(UpdateAttackListSenderSettingDocument, options);
}
export type UpdateAttackListSenderSettingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAttackListSenderSettingMutation, UpdateAttackListSenderSettingMutationVariables>;
export const DeleteAttackListSenderSettingDocument = gql`
    mutation deleteAttackListSenderSetting($ids: [ID!]!) {
  deleteAttackListSenderSettings(ids: $ids) {
    isSucceeded
  }
}
    `;

/**
 * __useDeleteAttackListSenderSettingMutation__
 *
 * To run a mutation, you first call `useDeleteAttackListSenderSettingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttackListSenderSettingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAttackListSenderSettingMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteAttackListSenderSettingMutation(options: VueApolloComposable.UseMutationOptions<DeleteAttackListSenderSettingMutation, DeleteAttackListSenderSettingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAttackListSenderSettingMutation, DeleteAttackListSenderSettingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteAttackListSenderSettingMutation, DeleteAttackListSenderSettingMutationVariables>(DeleteAttackListSenderSettingDocument, options);
}
export type DeleteAttackListSenderSettingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAttackListSenderSettingMutation, DeleteAttackListSenderSettingMutationVariables>;